<template>
  <Status v-if="status !== 'ready'" :type="status" />

  <div v-else class="page competitions">
    <router-link
      v-for="competition in competitions"
      :key="competition.id"
      :to="`/${competition.redirectUrl}`"
      :disabled="competition.id === null"
      class="competition"
    >
      <div class="title">
        {{ competition.short }}
      </div>
      <div class="subtitle">
        {{ competition.fullName }}
      </div>

      <img v-if="competition.imgUrl" :src="competition.imgUrl" :alt="competition.fullName" class="bg" />
    </router-link>

    <router-link to="/archiwum" class="archive">Archiwum wyników</router-link>
  </div>
</template>

<script>
import Status from "@/components/Status"
import { config } from "@/config"

export default {
  name: "Competitions",

  components: {
    Status,
  },

  data: () => ({
    competitions: null,
    status: "loading",
  }),

  created() {
    fetch(`${config.ManagerServer.rest.url}/globalView`)
      .then((response) => {
        if (response.ok) return response.json()
        throw new Error("Error loading data")
      })
      .then((data) => {
        this.competitions = data
        this.status = data.length ? "ready" : "empty"
      })
      .catch(() => (this.status = "error"))
  },
}
</script>

<style scoped lang="scss">
$_thumbSize: 30rem;
$_breakpoint: 900px;

.empty {
  margin: auto;
}

.competitions {
  padding: 2rem;
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr;

  @media (max-width: 600px) {
    .competition {
      min-height: $_thumbSize/3;
    }
  }
  @media (min-width: $_breakpoint) {
    grid-template-columns: repeat(auto-fit, minmax($_thumbSize, 1fr));
  }

  @media (min-width: 1600px) {
    grid-template-columns: repeat(10, 1fr);

    .competition:first-of-type {
      grid-column: span 4;
      grid-row: span 2;
    }

    .competition:nth-of-type(2),
    .competition:nth-of-type(3),
    .competition:nth-of-type(4),
    .competition:nth-of-type(5) {
      grid-column: span 3;
    }

    .competition {
      grid-column: span 5;
    }
  }
}

.competition {
  color: #fff;
  text-align: center;
  min-height: $_thumbSize;
  padding: 2rem;
  background: #000;
  box-shadow: 0 0 1rem 1rem rgba(#000, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  &[disabled] {
    pointer-events: none;
    background: rgba(#000, 0.55);

    .bg {
      opacity: 0.15;
      filter: grayscale(1);
    }
  }

  .title {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 1.5rem;
    z-index: 1;
  }

  .subtitle {
    font-size: 1rem;
    text-transform: uppercase;
    z-index: 1;
  }

  @media (min-width: $_breakpoint) {
    .title {
      font-size: 3.5rem;
    }

    .subtitle {
      font-size: 1.5rem;
    }
  }

  .bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.15;
    transition: opacity 250ms, transform 250ms;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
  }

  &:hover .bg {
    opacity: 0.35;
    transform: scale(1.025);
  }
}

.archive {
  color: #000;
  font-weight: bold;
  font-size: 1.5rem;
  text-transform: uppercase;
  text-align: center;
  padding: 3rem;
  background: #fff;
  display: block;
  grid-column: 1 / -1;
  box-shadow: 0 0 1rem 1rem rgba(#000, 0.05);
  transition: color 250ms, background 250ms;

  span {
    display: block;
    font-size: 1rem;
    opacity: 0.5;
  }

  &:hover {
    color: $primary;
    background: lighten($primary, 35%);
  }
}
</style>
